<script setup lang="ts">
import SmallPlayingCard from '@/views/SmallPlayingCard.vue'
import Typography from '../ui/typography/Typography.vue'
import { capitalize } from 'vue'
import type { CommunityCardAction } from '@acepoker/contract/src/action'
import { useI18n } from 'vue-i18n'

const { item } = defineProps<{ item: CommunityCardAction }>()
const { t } = useI18n()
</script>

<template>
  <div
    :class="`flex flex-row items-center w-max h-[24px] py-[3px] pr-[2px] pl-[6px] text-secondary rounded-[4px] gap-1`"
  >
    <Typography variant="topbarItem">{{ t(`label.${capitalize(item.type)}`) }}</Typography>
    <div class="flex flex-row">
      <small-playing-card
        v-for="(card, i) in item.action"
        :key="i"
        :value="card.rank + card.suit"
        class="w-[14.29px] h-[20px]! gap-0! rounded-[2.28px] [&>div]:text-[12px] [&>div]:leading-[12px] [&>img]:w-[8px] [&>img]:h-[8px] [&>img]:ml-[4px] [&>img]:mb-[3px] not-last:mr-[2px]"
      />
    </div>
  </div>
</template>
